angular.module('logbook')
.config([ 'stConfig', function(stConfig) { 
   stConfig.sort.delay = 10; 
   stConfig.pipe.delay = 20; 
}]);
